/* TeamCard — Premium team member card with avatar glow */

interface TeamCardProps {
  data: Record<string, string>
  entityData?: Record<string, unknown>
}

export default function TeamCard({ data, entityData }: TeamCardProps) {
  const name = (entityData?.name as string) || data.name || 'Team Member'
  const title = (entityData?.title as string) || (entityData?.specialty as string) || data.title || 'Specialist'
  const photo = (entityData?.photo_url as string) || data.photo || ''
  const bio = (entityData?.bio as string) || data.bio || ''

  return (
    <div data-testid="card-team" className="group relative h-full rounded-xl overflow-hidden bg-gradient-to-br from-white/[0.04] to-white/[0.01] border border-white/[0.06] hover:border-white/[0.12] transition-[border-color,transform,max-height,opacity] duration-300 hover:-translate-y-0.5">
      <div className="p-5 flex flex-col items-center text-center">
        {/* Avatar with glow ring */}
        <div className="relative mb-4">
          <div className="absolute -inset-1 rounded-full bg-gradient-to-br from-blue-500/20 to-purple-500/10 blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <div className="relative w-16 h-16 rounded-full overflow-hidden border-2 border-white/[0.08] group-hover:border-blue-500/30 transition-colors duration-300">
            {photo ? (
              <img
                src={photo}
                alt={name}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-white/10 to-white/[0.03] flex items-center justify-center">
                <span className="text-lg text-white/20 font-bold">
                  {name.charAt(0)}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Name */}
        <h4 className="text-sm font-semibold text-white/90 tracking-tight mb-0.5 group-hover:text-white transition-colors">
          {name}
        </h4>

        {/* Title */}
        <p className="text-[11px] text-blue-400/50 font-medium uppercase tracking-wider mb-3">
          {title}
        </p>

        {/* Bio (visible on hover) */}
        {bio && (
          <p className="text-[11px] text-white/25 leading-relaxed line-clamp-3 max-h-0 group-hover:max-h-20 overflow-hidden transition-[border-color,transform,max-height,opacity] duration-500 ease-out">
            {bio}
          </p>
        )}
      </div>
    </div>
  )
}
